import { RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, tap } from 'rxjs';
import { LocalStorageKeysEnum } from '@cp/shared/data-access/shared/enums';

export function redirectIfUnauthenticated(
  state: RouterStateSnapshot,
): Observable<boolean> {
  const authService = inject(AuthService);

  return authService.isAuthenticated$.pipe(
    tap((loggedIn) => {
      if (!loggedIn) {
        // /dashboard is included because when logging out, Auth0 redirects to route
        // which redirects to /dashboard. We will let Angular handle this, and not
        // our LogInTargetComponent.
        //
        // /log-out is included because it will create an infinite loop. Instead,
        // default behaviour in LogInTargetComponent will handle.
        //
        // /logged-in is included because it will also create an infinite loop.
        //
        // /error is auth0 error page
        const includesForbiddenRoutes = [
          '/dashboard',
          '/log-out',
          '/logged-in',
          '/callback',
          '/error',
        ].includes(state.url);

        // Just in case user has manually put a forbidden route in local storage.
        if (includesForbiddenRoutes) {
          localStorage.removeItem(LocalStorageKeysEnum.reRouteAfterLogIn);
        }

        // Set the route we want to go to if accepted route.
        if (!includesForbiddenRoutes) {
          localStorage.setItem(
            LocalStorageKeysEnum.reRouteAfterLogIn,
            state.url,
          );
        }
        // Redirects handled in LogInTargetComponent.
        authService.loginWithRedirect({
          appState: { target: '/logged-in' },
        });
      }
    }),
  );
}
